<template>
  <tr>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
    <td
      v-for="filter in updatedFilters"
      :key="filter.field"
      class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
    >
      <v-text-field
        v-if="filter.type === 'text'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        type="text"
        @keyup.enter="getData"
        hide-details="true"
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        @click:clear="clearFilterData(filter.field)"
      />
      
      <v-menu
        v-else-if="filter.type === 'date'"
        v-model="filter.menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="filter.label"
            v-model="filter.formatted"
            v-bind="attrs"
            @blur="updateDateValue(filter.field, filter.formatted)"
            v-on="on"
            hide-details="true"
            dense
            clearable
            @click:clear="clearFilterData(filter.field)"
          />
        </template>
        <v-date-picker
          v-model="searchData[filter.field]"
          no-title
          :max="today"
          scrollable
          @input="closeMenu(filter.field)"
        >
        <v-spacer />
          <v-btn text color="primary" @click="closeMenu(filter.field)">Cancel</v-btn>
        </v-date-picker>
      </v-menu>

      <v-autocomplete
        v-else-if="filter.type === 'autocomplete'"
        clearable
        v-model="searchData[filter.field]"
        :items="filter.items"
        item-text="userID"
        item-value="id"
        :label="filter.label"
        :loading="loadingActiveUser"
        :search-input.sync="searchActiveUser"
        @change="getData"
        hide-selected
        hide-details="true"
        dense
      />

      <v-autocomplete
        v-else-if="filter.type === 'autocomplete-async'"
        clearable
        v-model="searchData[filter.field]"
        :items="asyncFilters[filter.field].items"
        item-text="display_text"
        item-value="id"
        :label="filter.label"
        :loading="asyncFilters[filter.field].loading"
        :search-input.sync="asyncFilters[filter.field].searchInput"
        :menu-props="{ contentClass: 'autocomplete-filter-menu', maxHeight: 300 }"
        @change="onAsyncFilterChange(filter.field, $event)"
        hide-details="true"
        dense
      />

      <v-select
        v-else-if="filter.type === 'select'"
        :label="filter.label"
        v-model="searchData[filter.field]"
        :items="filter.items"
        item-text="text"
        item-value="value"
        @change="getData"
        clearable
        hide-details="true"
        dense
      />
    </td>
    <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row" />
  </tr>
</template>

<script>
import { formatDate, parseDate, date } from '../../../../lib/helpers';
import { dataSourceOnboardingList, dataListTaskType, dataAllQrType, dataListTrackingPengajuanStatus } from '../attributes';

export default {
  props: ['search', 'options'],
  data() {
    return {
      searchActiveUser: '',
      filters: [
        { label: 'Source Onboarding', field: 'source_onboarding', type: 'select', items: dataSourceOnboardingList },
        { label: 'Inputer ID - Name', field: 'request_by', type: 'autocomplete', items: [] },
        { label: 'Nama Merchant', field: 'merchant_name', type: 'text' },
        { label: 'Reference No', field: 'reference_number', type: 'text' },
        { label: 'MID', field: 'mid', type: 'text' },
        { label: 'Jenis Pengajuan', field: 'task_type', type: 'select', items: dataListTaskType },
        { label: 'Jenis QR', field: 'qr_type', type: 'select', items: dataAllQrType },
        { label: 'Branch Code BC/KO', field: 'bcko', type: 'autocomplete-async' },
        { label: 'Merchant Category Segment', field: 'cmer', type: 'autocomplete-async' },
        { label: '', field: '', type: '' },
        { label: 'Last Update', field: 'updated_at', type: 'date', menu: false, formatted: '' },
        { label: 'Status', field: 'status', type: 'select', items: dataListTrackingPengajuanStatus },
      ],
      asyncFilters: {
        bcko: { items: [], loading: false, searchInput: '', selectedId: '' },
        cmer: { items: [], loading: false, searchInput: '', selectedId: '' },
      },
      asyncDebouncers: {},
    };
  },
  computed: {
    today() {
      return new Date().toLocaleDateString('sv-SE');
    },
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    itemsActiveUser() {
      return this.$store.state.users.allActiveUser;
    },
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    updatedFilters() {
      return this.filters.map(filter => {
        if (filter.field === 'request_by') {
          return { ...filter, items: this.itemsActiveUser };
        }
        return filter;
      });
    },
  },
  watch: {
    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, 500);
      },
    },
    'searchData.updated_at': {
      handler(newVal) {
        const dateFilter = this.filters.find(f => f.field === 'updated_at');
        if (dateFilter) {
          dateFilter.formatted = formatDate(newVal);
        }
        this.getData();
      },
    },
    'asyncFilters.bcko.searchInput': function bckoSearchInputWatcher(val, oldVal) {
      this.onAsyncSearchInput('bcko', val, oldVal);
    },
    'asyncFilters.cmer.searchInput': function cmerSearchInputWatcher(val, oldVal) {
      this.onAsyncSearchInput('cmer', val, oldVal);
    },
  },
  created() {
    this.asyncDebouncers.bcko = this.createDebounced(this.fetchBckoList, 300);
    this.asyncDebouncers.cmer = this.createDebounced(this.fetchCmerList, 300);
  },
  mounted() {
    this.fetchBckoList();
    this.fetchCmerList();
  },
  beforeDestroy() {
    this.resetFilters();
    this.$store.commit('trackingPengajuan/clearMerchants');
  },
  methods: {
    resetFilters() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = '';
      });
    },
    getActiveUser() {
      this.$store.dispatch('users/getActiveUser', {
        date,
        userID: this.searchActiveUser,
      });
    },

    clearFilterData(field) {
      this.searchData[field] = '';
      this.getData();
    },
    updateDateValue(field, formattedValue) {
      const parsedDate = parseDate(formattedValue);
      if (parsedDate) {
        this.searchData[field] = parsedDate;
      }
    },
    closeMenu(field) {
      const dateFilter = this.filters.find(f => f.field === field);
      if (dateFilter) {
        this.$set(dateFilter, 'menu', false);
      }
    },
    getData() {
      const newOptions = { ...this.options, page: 1 };
      this.$emit('update:options', newOptions);
    },

    async fetchBckoList(keyword = '') {
      this.asyncFilters.bcko.loading = true;
      const result = await this.$store.dispatch('bckoShared/getBcko', { keyword, showAll: true, limit: 9999 });
      if (result.success) {
        this.asyncFilters.bcko.items = result.data.map(item => ({
          ...item,
          display_text: `${item.branch_code_bcko} - ${item.outlet_name}`,
        }));
      }
      this.asyncFilters.bcko.loading = false;
    },

    async fetchCmerList(keyword = '') {
      this.asyncFilters.cmer.loading = true;
      const result = await this.$store.dispatch('cmerShared/getCmer', { keyword, showAll: true, limit: 9999 });
      if (result.success) {
        this.asyncFilters.cmer.items = result.data.map(item => ({
          ...item,
          display_text: `${item.code} - ${item.definition}`,
        }));
      }
      this.asyncFilters.cmer.loading = false;
    },

    onAsyncSearchInput(field, val, oldVal) {
      if (!val && !oldVal) return;
      if (this.isSelectedDisplayText(field, val)) return;
      const debounced = this.asyncDebouncers[field];
      if (debounced) debounced(val || '');
    },

    onAsyncFilterChange(field, value) {
      this.asyncFilters[field].selectedId = value || '';
      this.searchData[field] = value || '';
      this.getData();
    },

    isSelectedDisplayText(field, val) {
      const state = this.asyncFilters[field];
      if (!state || !state.selectedId || !val) return false;
      const selected = state.items.find(item => item.id === state.selectedId);
      return !!(selected && selected.display_text === val);
    },

    createDebounced(fn, delay) {
      let timer = null;
      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
  },
};
</script>